import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AppInterceptor implements HttpInterceptor {
  constructor(private spinner: NgxSpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.spinner.show();

    if (!req.headers) {
      let headers: HttpHeaders = new HttpHeaders({
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*, *",
        "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
      });
      req = req.clone({
        headers: headers
      });
    }
    return next.handle(req).do((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        this.spinner.hide();
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        const started = Date.now();
        const elapsed = Date.now() - started;
        //console.log(`Request for ${req.urlWithParams} failed after ${elapsed} ms.`);
        // debugger;
      }
    })
  }
}